// getInputPlaceholder — pure derivation of the chat input placeholder text.
//
// Extracted verbatim from `AIChatBot.js` (the in-component `inputPlaceholder`
// expression) as part of the behavior-preserving refactor (issue #240). Maps the
// current hotel-search state to the matching placeholder string, falling back to
// the generic "Ask Dan about..." prompt for any other state.
//
// React-free and side-effect-free. Total over any input (unknown states fall
// through to the default), matching the source's ternary chain exactly.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Derives the input placeholder for the current hotel-search state.
 *
 * @param {null|'awaiting_location'|'awaiting_brand'|'awaiting_budget'|string} hotelSearchState
 *   The current hotel-search state-machine value.
 * @returns {string} The placeholder text for the chat input.
 */
export function getInputPlaceholder(hotelSearchState) {
  return (
    hotelSearchState === 'awaiting_location' ? 'Or type a location preference...' :
    hotelSearchState === 'awaiting_brand' ? 'Or type a brand name...' :
    hotelSearchState === 'awaiting_budget' ? 'Or describe your budget...' :
    'Ask Dan about hotels, dining, activities...'
  );
}

export default getInputPlaceholder;
